import { UtilityTariffsDatabaseSubtitle } from '../utilityTariffs/catalogue/UtilityTariffsDatabaseSubtitle'

export default {
  list: { lazy: () => import('./UtilityTariffGroup'), component: 'UtilityTariffGroupList' },
  options: {
    list: {
      title: 'Utility Tariffs',
      subtitle: <UtilityTariffsDatabaseSubtitle />,
      breadCrumb: 'Utility Tariffs',
    },
  },
}
